import { createTheme } from '@mui/material/styles';

export const theme = createTheme({
  typography: {
    body3: {
      display: 'block',
      fontSize: '0.9rem',
      lineHeight: '1rem',
    },
    body4: {
      display: 'block',
      fontSize: '0.75rem',
      lineHeight: '0.9rem',
    },
    h3: {
      fontSize: '1.75rem',
      fontWeight: 500,
      lineHeight: '1.5rem',
    },
    h5: {
      fontSize: '1.05rem',
      fontWeight: 600,
      lineHeight: '0.9rem',
    },
    captionItalic: {
      fontStyle: 'italic',
      fontSize: '0.8rem',
      lineHeight: '1rem',
      color: '#555',
      display: 'block',
    },
  },
  palette: {
    blue: {
      light: '#badffb',
      main: '#557fad',
      dark: '#30497B',
      contrastText: '#fff',
    },
    turquoise: {
      light: '#a0e0e0',
      main: '#00cbdf',
      dark: '#00cbdf',
      contrastText: '#fff',
    },
    fuscia: {
      light: '#bd85b4',
      main: '#a04e94',
      dark: '#a04e94',
      contrastText: '#fff',
    },
    purple: {
      light: '#9385B2',
      main: '#665091',
      dark: '#665091',
      contrastText: '#fff',
    },
    orange: {
      light: '#ef7a40',
      main: '#ef7a40',
      dark: '#ef7a40',
      contrastText: '#fff',
    },
    neutral: {
      light: '#ccc',
      main: '#555',
      dark: '#444',
      contrastText: '#fff',
    },
    green: '#008000',
    yellow: '#feb406',
    red: '#ff0000',
  },
});
